import { IOmniaSettings, LayerViewModel, LmNode, selectMany } from "../omnia"
import { IDatalayersService } from "../types"
import { LmRoot } from "./explorer"

let state: {
    rootId: string
}

let explorerState: { [rootId: string]: string[][] } = {}

export function saveState(svc: IDatalayersService, settings: IOmniaSettings, layers: LayerViewModel[], root: LmRoot & { nodes: LmNode[] }) {

    const visibleLayers = layers.filter(l => l.visible).map(l => l.datalayerId)

    svc.setVisibleLayers(visibleLayers)

    state = {
        rootId: root.id,
    }

    settings.set("menu", state)

    saveExplorerState(root)

}

export function saveExplorerState(root: LmRoot & { nodes: LmNode[] }) {

    explorerState[root.id] = getExpandedNodes(root.nodes, [])

}

export function restoreExplorerState(root: LmRoot & { nodes: LmNode[] }) {

    const paths = explorerState[root.id]

    if (paths) {
        expandNodes(root.nodes, paths)
    }
    else if (root.setDefaults) {
        root.setDefaults(root.nodes)
    }

}

function getExpandedNodes(nodes: LmNode[], path: string[]): string[][] {

    const paths = (nodes || []).filter(n => n.expanded).map(n => {
        const npath = path.concat([n.id])
        const c = getExpandedNodes(n.getChildren(), npath)
        return c.length ? c : [npath]
    })

    return selectMany(paths)

}

export function restoreState(svc: IDatalayersService, settings: IOmniaSettings, layers: LayerViewModel[], roots: LmRoot[]) {

    state = state || settings.get("menu") || ({ rootId: "fields" })

    layers.forEach(l => l.visible = svc.getLayerVisibility(l.datalayerId))

    const root = roots.find(r => r.id == state.rootId) || roots[0]

    return {
        root
    }

}

export function expandNodes(nodes: LmNode[], paths: string[][]) {

    if (paths) {

        paths.forEach(p => expand(nodes, p))

    }

    function expand(nodes: LmNode[], path: string[]) {

        if (path.length) {

            const id = path[0]
            const node = nodes.find(n => n.id == id)

            if (node) {
                node.expanded = true
                expand(node.getChildren(), path.slice(1))
            }

        }

    }

}
